module.exports = __webpack_public_path__ + "static/media/013_inovacao.826fa282.mp4";